export default class MusicTranscriptionTimer {
  private timeValue: number[] = []; // Push to the array every time the timer is incremented
  private initialTimer = 0;
  private startTime = 0; // Measured time in milliseconds
  private recordStartAt = 0;// Measured time in milliseconds
  private divisionStartAt = 0;// Measured time in milliseconds
  private isDivisionStartAtMeasured = false
  public value: number = 0;

  get timeValueArray() {
    return this.timeValue;
  }

  get initialTimerValue() {
    return this.initialTimer;
  }

  get startTimeValue() {
    return this.startTime;
  }

  get recordStartAtValue() {
    return this.recordStartAt
  }
  
  get divisionStartAtValue() {
    return this.divisionStartAt
  }

  setRecordStartAt() {
    this.divisionStartAt = performance.now()
    this.isDivisionStartAtMeasured = false
    this.recordStartAt = this.divisionStartAt
  }

  computeDivisionStartAt() {
    if(!this.isDivisionStartAtMeasured) {
      this.divisionStartAt = -this.divisionStartAt + performance.now();
      this.isDivisionStartAtMeasured = true;
    }
  }

  setTimer(value: number) {
    this.value = value;
  }

  reset(initialTimer = 0) {
    this.timeValue.length = 0;
    this.initialTimer = initialTimer;
    this.startTime = performance.now();
    this.isDivisionStartAtMeasured = false;
    this.value = 0
  }

  increment(){
    this.timeValue.push(performance.now() - this.startTime);
  }
}